import React, {createContext, useContext, useMemo} from "react";

const PreventativeGridActionsContext = createContext(null);

export const PreventativeGridActionsProvider = ({
    children,
    openCreationForCell,
    openImportForCell,
    addPropertyOptionForCell,
    addingPropertyOptionCellKey = null,
}) => {
    const value = useMemo(() => ({
        openCreationForCell,
        openImportForCell,
        addPropertyOptionForCell,
        addingPropertyOptionCellKey,
    }), [openCreationForCell, openImportForCell, addPropertyOptionForCell, addingPropertyOptionCellKey]);

    return (
        <PreventativeGridActionsContext.Provider value={value}>
            {children}
        </PreventativeGridActionsContext.Provider>
    );
};

export const usePreventativeGridActions = () => {
    const ctx = useContext(PreventativeGridActionsContext);
    if (!ctx) {
        throw new Error('usePreventativeGridActions must be used within PreventativeGridActionsProvider');
    }
    return ctx;
};
